export default class ValidationErrorHandler {
    constructor(messageBag) {
        this.defaultReturnType = [];
        this.messageBag = this.setMessageBag(messageBag)
    }

    get message() {
        if (Array.isArray(this.messageBag) && "message" in this.messageBag) {
            return this.messageBag.message;
        }
        return "The given data was invalid"
    }

    setMessageBag(bag) {
        if (bag && bag.response && bag.response.data) {
            return this.messageBag = bag.response.data
        }
        if (bag && !bag.errors) {
            return this.messageBag = {errors: bag}
        }
        return this.messageBag = bag
    }

    setDefaultReturnType(type) {
        this.defaultReturnType = type;
        return this;
    }

    clearErrors() {
        this.messageBag = {};
    }

    hasErrors() {
        if (!this.messageBag || !this.messageBag.errors) return false;
        return Object.keys(this.messageBag.errors).length > 0
    }

    getErrors() {
        return Object.get(this.messageBag, 'errors', {})
    }

    getField(field) {
        if (this.messageBag && this.messageBag.errors && this.messageBag.errors[field]) {
            return this.messageBag.errors[field][0]
        }
        return this.defaultReturnType
    }

    clearFieldErrorMessage(field) {
        if (!this.messageBag) return '';
        return this.messageBag.errors[field] = "";
    }
}